import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
// import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import validations from "../../../../../../helpers/validations";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";
// import DynamicForm from "../../../../DynamicForm/DynamicForm";

const AddBattery = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [userTypedd, setUserTypedd] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  // const [unitOptions, setUnitOptions] = useState([]);
  const [hsncodeOptions, setHsncodeOptions] = useState([]);
  const [warrantyOptions, setWarrantyOptions] = useState([]);
  const [varientOptions, setVarientOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [itemCategory, setItemcategoryOptions] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const [taxsetDropdown, setTaxSet] = useState([]);

  useEffect(() => {
    fetchItemDD();
    // fetchUnitDD();
    fetchHsncodeDD();
    fetchWarrrantyDD();
    fetchModelOptions();
    fetchVarientOptions();
    fetchColorOptions();
    fetchTaxSetDropdown();
    fetchItemCategoryOptions();
  }, [formData?.business_partner_id]);

  const fetchWarrrantyDD = async () => {
    try {
      const payload = {
        orderBy: "warranty_id desc",
        page: 0,
        pageSize: 100,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        "/warranty/ddlwarranty",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));

      setWarrantyOptions(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };
  const fetchModelOptions = async (makeId) => {
    try {
      const payload = {
        orderBy: "model_id desc",
        page: 0,
        pageSize: 100,
        make_id: makeId,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post("/model/ddlmodel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));

      setModelOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };
  const fetchVarientOptions = async (makeId) => {
    try {
      const payload = {
        page: 0,
        pageSize: 100,
        make_id: makeId,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));

      setVarientOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  // color options Api
  const fetchColorOptions = async (makeId) => {
    try {
      const payload = {
        page: 0,
        pageSize: 100,
        make_id: makeId,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post("/color/ddlcolor", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((color) => ({
        label: color.NAME,
        value: color.ID,
      }));

      setColorOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  const fetchItemCategoryOptions = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        "/partcategory/ddlpartcategory",
        {
          // itemtype_id: itemtypeid,
          // variant_id:variantIdVal,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setItemcategoryOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  // const fetchUnitDD = async () => {
  //   try {
  //     const payload = {
  //       orderBy: "unit_id desc",
  //       page: 0,
  //       pageSize: 100,
  //     };

  //     if (userType === "superadmin") {
  //       payload.business_partner_id = formData.business_partner_id;
  //     } else {
  //       payload.business_partner_id = businessPartnerId;
  //     }

  //     const response = await axiosInstance.post("/unit/ddlunit", payload, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     });

  //     const options = response.data.data.data.map((product) => ({
  //       label: product.NAME,
  //       value: product.ID,
  //     }));

  //     setUnitOptions(options);
  //   } catch (error) {
  //     console.error("Error fetching product options:", error);
  //   }
  // };
  const fetchHsncodeDD = async () => {
    try {
      const payload = {
        orderBy: "hsncode_id desc",
        page: 0,
        pageSize: 100,
      };

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        "/hsncode/ddlhsncode",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));

      setHsncodeOptions(options);
    } catch (error) {
      console.error("Error hsncode options:", error);
    }
  };
  const fetchTaxSetDropdown = async () => {
    try {
      const response = await axiosInstance.post(
        "/tax/ddltax",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data;
      console.log(formattedData, "VARIANTDATA");

      const variantData = formattedData.map((data) => ({
        value: data.ID,
        label: data.NAME,
        tax_percent: data?.tax_percent,
      }));

      setTaxSet(variantData);
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
  };

  const fetchItemDD = async () => {
    try {
      const payload = {
        orderBy: "item_id desc",
        page: 0,
        pageSize: 100,
      };

      const response = await axiosInstance.post("/itemtype/list", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((product) => ({
        label: product.itemtype,
        value: product.itemtype_id,
      }));

      setProductOptions(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  const handleFormSubmit = async (data) => {
    const errors = {};
    let isValid = true;

    // Validate form fields
    ItemInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!data[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(data[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (
      formData.purchasePrice &&
      formData.sellingPrice &&
      Number(formData.purchasePrice) > Number(formData.sellingPrice)
    ) {
      errors.purchasePrice =
        "Purchase Price cannot be greater than Selling Price";
      isValid = false;
    }

    // If validation fails, set errors and return
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    //
    // SweetAlert confirmation before API call
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to create this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      preConfirm: async () => {
        const payload = {
          battery_name: data.batteryName,
          brand_name: data.batteryBrand,
          selling_price: data.sellingPrice,
          purchase_price: data.purchasePrice,
          batteryType: data.batteryType,
          warranty_id: data.warranty,
          hsnCode_id: data.hsnCode,
          // Unit_id: data.unitQuantity,
          tax_id: data?.taxid,
          status: data.status === true ? 1 : 0, // Ensure it's either 1 or 0
        };
        // "item_image": "abc"

        // Validate and Log the Payload
        console.log("Payload Data:", JSON.stringify(payload, null, 2));

        try {
          const newformData = new FormData();

          Object.entries(payload).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
              newformData.append(key, value);
            }
          });
          if (formData.uploadImage) {
            newformData.append("batteryFile", formData.uploadImage);
          }
          setLoading(true);

          const response = await axiosInstance.post(
            "/battery/create-battery",
            newformData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${authToken}`,
              },
            },
          );

          console.log("API Response By A:", response.data.data);

          // showCustomAlert({
          //   title: "Success",
          //   text: "Item created successfully.",
          //   icon: "success",
          //   confirmButtonText: "OK",
          //   callback: () => {
          //     navigate("/admin/manage-product/item");
          //   },
          // });
          if (response.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Battery added successfully!",
              icon: "success",
              confirmButtonText: "OK",
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then(() => {
              navigate(ROUTES_NAVIGATION.BATTERYLIST);
            });
          }
        } catch (error) {
          // console.error("Error creating item:", error?.response?.data || error);
          // showCustomAlert({
          //   title: "Error",
          //   text: "Failed to create item. Please try again later.",
          //   icon: "error",
          //   confirmButtonText: "OK",
          // });
          const errorMessage = error.response?.data?.data;
          console.log(errorMessage, "errorMessage");

          showErrorAlert({
            title: errorMessage || "Something went wrong",
            text:
              errorMessage ||
              "An error occurred while processing your request.",
            callback: () => {
              // Optional: code to execute after confirming the alert
              console.log("Error alert confirmed");
            },
          });
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const ItemInputs = [
    {
      name: "batteryName",
      label: "Battery Name",
      placeholder: "Enter Battery Name",
      type: "text",
      required: true,
      validation: validations.batteryName({ required: true }),
      gridClass: "col-lg-4",
    },
    // {
    //   name: "batteryType",
    //   label: "Item Type",
    //   type: "dropdown",
    //   options: productOptions,
    //   required: true,
    //   validation: {
    //     required: true,
    //   },
    //   gridClass: "col-lg-4",
    // },
    {
      name: "batteryCode",
      label: "Battery Code",
      placeholder: "Enter Battery Code",
      type: "text",
      // required: true,
      validation: validations.batteryCode({}),
      gridClass: "col-lg-4",
    },
    {
      name: "batteryType",
      label: "Battery Type",
      placeholder: "Enter",
      type: "dropdown",
      options: [
        { value: "L", label: "Lithium Battery" },
        { value: "G", label: "Graphene Battery" },
        // { value: "N", label: "No Battery" },
      ],
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "batteryBrand",
      label: "Battery Brand",
      placeholder: "Enter Battery Brand Name",
      type: "text",
      required: true,
      validation: validations.batteryBrandName({ required: true }),
      gridClass: "col-lg-4",
    },
    {
      name: "purchasePrice",
      label: "Purchase Price",
      placeholder: "Enter Purchase Price",
      type: "number",
      isDecimal: true,
      validation: validations.price({ required: true }),
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "sellingPrice",
      label: "Selling Price",
      placeholder: "Enter Selling Price",
      type: "number",
      isDecimal: true,
      validation: validations.price({ required: true }),
      required: true,
      gridClass: "col-lg-4",
    },

    {
      name: "warranty",
      label: "Warranty",
      type: "dropdown",
      required: true,
      options: warrantyOptions,
      validation: {
        required: true,
      },
      gridClass: "col-lg-4",
    },

    {
      name: "taxid",
      label: "Tax",
      type: "dropdown",
      required: true,
      options: taxsetDropdown,
      validation: {
        required: true,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "hsnCode",
      label: "HSN Code",
      //placeholder: "Enter HSN Code",
      type: "dropdown",
      options: hsncodeOptions,
      validation: {
        required: true,
        // pattern: /^[0-9\s]*$/,
        //message: "Only Digits are allowed*",
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "uploadImage",
      label: "Upload",
      type: "file",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      // required: true,
      // validation: {
      //   required: true,
      // },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",

      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Add Battery</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter Battery Details
              </span>
              <DynamicForm
                formConfig={ItemInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(ItemInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  ItemInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => {
                  handleFormSubmit(formData);
                }}
              >
                {loading ? "Processing..." : "Submit"}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddBattery;
